import { dataDoDia, moeda } from '../../formato';
import type { WizardState } from './types';
import type { EstagioEmissao } from './useEmissao';

interface Props {
  estado: WizardState;
  estagio: EstagioEmissao;
  mensagem: string;
  erro: string | null;
  /** Pré-pago debita o crédito; o resto vai à fatura. A linha dizia "débito de crédito" a todos. */
  prePago: boolean;
  onSolicitar: () => void;
}

const TEXTO_ESTAGIO: Record<EstagioEmissao, string> = {
  ocioso: 'Solicitar ATF',
  'criando-cte': 'Emitindo documentação…',
  'autorizando-sefaz': 'Autorizando na SEFAZ…',
  'solicitando-atf': 'Solicitando a ATF…',
  concluido: 'Concluído',
};

/**
 * Passo 8 (revisão) — handoff §2: os pares rótulo/valor, o valor e "Solicitar ATF".
 * Consome a sequência de 3 estágios (useEmissao.ts).
 */
export function PassoRevisao({ estado, estagio, mensagem, erro, prePago, onSolicitar }: Props) {
  const processando = estagio !== 'ocioso' && estagio !== 'concluido';
  const valor = moeda(estado.valorCentavos / 100);

  return (
    <div>
      <div className="co-cartao co-revisao">
        <dl className="co-pares">
          <dt>Condutor</dt>
          <dd>{estado.condutorNome || '—'}</dd>
          <dt>Veículo</dt>
          <dd>{estado.placa || '—'}</dd>
          <dt>Rota</dt>
          <dd>
            {estado.municipioOrigemNome && estado.municipioDestinoNome
              ? `${estado.municipioOrigemNome} → ${estado.municipioDestinoNome}`
              : '—'}
          </dd>
          <dt>Datas</dt>
          <dd>
            {`${dataDoDia(estado.dataIda)} ${estado.horarioIda}`}
            {!estado.somenteIda && ` → ${dataDoDia(estado.dataVolta)} ${estado.horarioVolta}`}
          </dd>
          <dt>Trajeto</dt>
          <dd>{`${estado.kmIda}${!estado.somenteIda ? ` / ${estado.kmVolta}` : ''} km`}</dd>
          <dt>Passageiros</dt>
          <dd>{estado.passageiros.length}</dd>
          <dt>Valor declarado</dt>
          <dd>{valor}</dd>
        </dl>
      </div>

      <div className="co-debito">
        <span>{prePago ? 'Sai do seu crédito nesta emissão' : 'Vai para a sua fatura'}</span>
        <strong>{valor}</strong>
      </div>

      {processando && <p className="co-progresso" role="status">{mensagem || TEXTO_ESTAGIO[estagio]}</p>}
      {erro && !processando && <p className="co-erro" role="alert">{erro}</p>}

      {estagio === 'concluido' ? (
        <p className="co-nota co-nota-sucesso" role="status">
          Solicitação enviada ao DER. Acompanhe a resposta em Minhas ATFs.
        </p>
      ) : (
        <div className="co-acoes">
          <button type="button" className="co-btn co-btn-primario co-btn-largo" onClick={onSolicitar} disabled={processando}>
            {processando ? TEXTO_ESTAGIO[estagio] : erro ? 'Tentar novamente' : 'Solicitar ATF'}
          </button>
        </div>
      )}
    </div>
  );
}
